import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { createNewFlow } from "redux/actions/portal/flowsActionCreator";
import { getFlowVersionById } from "api/FlowVersions";
import { fetchFlowById } from "api/FlowDesignerApis";
import { uncompressRows } from "../helpers/common";
import { retrieveJson } from "api/FlowDesignerApis";

const useCloneFlow = () => {
   const { currentSavedFlow } = useSelector((state) => state.designer.flows);
   const { user } = useAuth0();
   const dispatch = useDispatch();

   const handleCloneFlow = async (from_library = false, flow, from_flow_version, version) => {
      let flowToUse = currentSavedFlow;

      if (from_library) {
         const fetchedFlow = await fetchFlowById(user?.stripeId, flow.id);

         if (fetchedFlow) {
            flowToUse = fetchedFlow;
         }
      }

      let input = {
         created_by: user?.name,
         created_by_id: user?.cxfUserId,
         description: flowToUse?.description,
         group_id: flowToUse?.group_id,
         group_name: flowToUse?.group_name,
         name: flowToUse?.name,
         platform_name: flowToUse?.platform_name,
         platform_type: flowToUse?.platform_type,
         notes: flowToUse?.notes,
         steps: from_flow_version ? version.steps : flowToUse?.steps,
         shared_status: flowToUse?.shared_status ?? "draft",
         shared_link: flowToUse?.shared_link,
         trashed: false,
         flow_settings: "",
         integrations: flowToUse?.integrations,
         logo: flowToUse?.logo,
         documentation: flowToUse?.documentation,
         notify_for_delete: flowToUse?.notify_for_delete,
         notify_for_moved_to_trash: flowToUse?.notify_for_moved_to_trash,
         connectors: flowToUse?.connectors,
         credentials: flowToUse?.credentials,
         current_version: "1.0",
         clone_flow: {}
      };

      const flow_id = flow ? flow.id : currentSavedFlow?.id;
      const clone_flow_version = version?.version ? version.version : flow.current_version ? flow.current_version : "1.0";
      const flow_configuration_key = `${user?.stripeId}-${flow_id}-${clone_flow_version}-config`;
      const flow_configuration = await retrieveJson(flow_configuration_key);
      const sourceFlowSettings = flowToUse?.flow_settings
         ? typeof flowToUse.flow_settings === "string"
            ? JSON.parse(flowToUse.flow_settings)
            : flowToUse.flow_settings
         : {};

      input.clone_flow.flow_configuration = flow_configuration.resultObject ?? {};
      input.clone_flow.shared_flow_configuration_keys = Array.isArray(sourceFlowSettings.sharedFlowConfigurationKeys)
         ? sourceFlowSettings.sharedFlowConfigurationKeys
         : [];
      input.clone_flow.original_flow_id = flow_id;

      if (from_flow_version && version) {
         const latestFlowVersionInformation = await getFlowVersionById(currentSavedFlow.id, version.version);

         const flowVersion = latestFlowVersionInformation?.resultObject;

         if (flowVersion) {
            input.steps = flowVersion.steps;
            input.connectors = flowVersion.connectors;
            input.credentials = flowVersion.credentials;
         }
      }

      if (from_library) {
         input.flow_settings = flow.flow_settings;
      } else {
         input.flow_settings = currentSavedFlow?.flow_settings ? (typeof currentSavedFlow.flow_settings === "string" ? currentSavedFlow.flow_settings : JSON.stringify(currentSavedFlow?.flow_settings)) : null;

         input = uncompressRows(input);
      }

      dispatch(
         createNewFlow(user?.stripeId, input, user, undefined, {
            isClone: true,
            recreateDependencies: from_library && !version
         })
      );
   };

   return { handleCloneFlow };
};

export default useCloneFlow;
